export default __webpack_public_path__ + "static/media/2.11.50f30379.mp3";